// The background of a banner that asks for attention: the expired trial banner (subscription_banner.tsx) and the
// planner's refused-save banner (admin/org/song_list_save_refusal_banner.tsx).
export const attentionBannerBackground = '#faece7';
export const attentionBannerDarkBackground = '#4d312d';
